import React from "react";
import classes from "./Button.module.css";

const Button = (props) => {
  const classNames = [
    classes.Button,
    props.type === "Primary"
      ? classes.Primary
      : props.type === "Secondary"
      ? classes.Secondary
      : props.type === "Danger"
      ? classes.Danger
      : null,
  ].join(" ");
  return (
    <>
      {props.href ? (
        <button
          href={props.href}
          onClick={() => {
            window.location.href = props.href;
          }}
          rel="noreferrer"
          target="_blank"
          className={classNames}
        >
          {props.children}
        </button>
      ) : (
        <button onClick={props.click} className={classNames}>
          {props.children}
        </button>
      )}
    </>
  );
};

export default Button;
